import { apiClient } from './client';
import type { FormSubmission } from '../../types/entities';

export const formSubmissionsApi = {
  /**
    * Get all submissions for a form by tenant slug and form name
    * GET /tenants/:tenantSlug/forms/:formName/data
    */
  getAllForForm: async (
    tenantSlug: string,
    formName: string
  ): Promise<FormSubmission[]> => {
    return apiClient.get<FormSubmission[]>(`/tenants/${tenantSlug}/forms/${formName}/data`);
  },

  /**
    * Create a new form submission
    * POST /tenants/:tenantSlug/forms/:formName/data
    */
  create: async (
    tenantSlug: string,
    formName: string,
    data: Record<string, unknown>
  ): Promise<FormSubmission> => {
    return apiClient.post<FormSubmission>(
      `/tenants/${tenantSlug}/forms/${formName}/data`,
      data
    );
  },

  /**
    * Update a form submission
    * PUT /tenants/:tenantSlug/forms/:formName/data/:submissionId
    */
  update: async (
    tenantSlug: string,
    formName: string,
    submissionId: number,
    data: Record<string, unknown>
  ): Promise<FormSubmission> => {
    return apiClient.put<FormSubmission>(
      `/tenants/${tenantSlug}/forms/${formName}/data/${submissionId}`,
      data
    );
  },

  /**
    * Delete a form submission
    * DELETE /tenants/:tenantSlug/forms/:formName/data/:submissionId
    */
  delete: async (
    tenantSlug: string,
    formName: string,
    submissionId: number
  ): Promise<void> => {
    return apiClient.delete<void>(
      `/tenants/${tenantSlug}/forms/${formName}/data/${submissionId}`
    );
  },
};
